import { SELECT_POINT } from '../types';

export default (directionType, pointObject) => ({
  type: SELECT_POINT,
  directionType,
  pointObject,
});
